import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from "@angular/core";
import moment from "moment";
import { Subscription } from "rxjs";
import { AppService } from "src/app/core/services/app.service";
import { CustomerService } from "src/app/core/services/customer.service";
import { FocusdataService } from "src/app/core/services/focusdata.service";
import { FocuslinkService } from "src/app/core/services/focuslink.service";
import { CustomerVenueGroup } from "src/app/shared/models/CustomerVenueGroup.item";
import { CustomerDto } from "src/app/shared/models/DTO/customer-dto";
import { GenericLabelValue } from "src/app/shared/models/DTO/GenericLabelValue.dto";
import { AppMessageSeverity } from "src/app/shared/models/enums/AppMessageSeverity.enum";
import { CompareOperator } from "src/app/shared/models/enums/compare-operator.enum";
import { CustomerVenueGroupCriteria } from "src/app/shared/models/enums/customer-venue-group-criteria.enum";
import { MenuItemRecord } from "src/app/shared/models/focusDataModels/MenuItemRecord";

@Component({
	selector: "app-group-setup",
	templateUrl: "./group-setup.component.html",
	styleUrls: ["../../../commandcenter.scss"],
})
export class GroupSetupComponent implements OnInit, OnDestroy {
	@Input() customerGroup: CustomerVenueGroup;
	@Input() venueKey: number;
	@Output() onSave = new EventEmitter<CustomerVenueGroup>();
	@Output() onClear = new EventEmitter<boolean>();
	@Output() onDelete = new EventEmitter<string>();

	customerGroupValue: string;
	customerList: CustomerDto[];
	customerListSubscription: Subscription = new Subscription();

	menuItemList: MenuItemRecord[];
	moment: any = moment;

	criteria = [
		{
			label: "Average Spend",
			value: CustomerVenueGroupCriteria.AVERAGESPEND,
		},
		{
			value: CustomerVenueGroupCriteria.FIRSTVISIT,
			label: "First visit",
		},
		{
			value: CustomerVenueGroupCriteria.LASTVISIT,
			label: "Last visit",
		},
		{
			value: CustomerVenueGroupCriteria.PURCHASEDITEM,
			label: "Has purchased",
		},
		{
			value: CustomerVenueGroupCriteria.TOTALREVENUE,
			label: "Total spend",
		},
		{
			value: CustomerVenueGroupCriteria.VISITCOUNT,
			label: "Has visited",
		},
	];

	operator = [
		{
			value: CompareOperator.EQUALS,
			label: "equal to",
			disabled: false,
		},
		{
			value: CompareOperator.GREATERTHAN,
			label: "more than",
			disabled: false,
		},
		{
			value: CompareOperator.GREATERTHANEQUALTO,
			label: "more than or equals",
			disabled: false,
		},
		{
			value: CompareOperator.LESSTHAN,
			label: "less than",
			disabled: false,
		},
		{
			value: CompareOperator.LESSTHANEQUALTO,
			label: "less than or equals",
			disabled: false,
		},
		{
			value: CompareOperator.BETWEEN,
			label: "between",
			disabled: false,
		},
	];

	type: GenericLabelValue[] = [
		{
			label: "Dynamic Group",
			value: 1,
		},
		{
			label: "Selected Customers",
			value: 2,
		},
		{
			label: "All Customers",
			value: 3,
		},
	];

	constructor(public app: AppService, private focuslink: FocuslinkService, private focusdata: FocusdataService, public customerService: CustomerService) {}

	ngOnInit(): void {
		this.filterCriteria();
		this.menuItemListGet();
		if (this.customerGroup.lastCountResult) {
			this.customerGroupValue = `${this.customerGroup.lastCountResult} ${
				this.customerGroup.lastCountResult === 1 ? "customer" : "customers"
			} as of ${moment(this.customerGroup.lastCountDateTime).format("l LT")}`;
		}
		this.customerGroup.type = 1;
		this.customerListSubscription.add(
			this.customerService.customerList.subscribe((data) => {
				this.customerList = data
					.filter((i) => i.email && i.email !== "undefined" && (i.firstName || i.lastName))
					.map((i) => {
						const c = new CustomerDto(i);
						c.displayName = `${this.app.references.toTitleCase(c.firstName)} ${this.app.references.toTitleCase(
							c.lastName
						)} - ${c.email?.toLowerCase()}`;
						return c;
					});
			})
		);
	}

	ngOnDestroy() {
		this.customerListSubscription.unsubscribe();
	}

	delete() {
		this.onDelete.emit(this.customerGroup.sk);
		this.customerGroup = undefined;
		this.onClear.emit(true);
	}

	async save() {
		try {
			this.focuslink.customerGroupPost(this.venueKey, this.customerGroup);
			this.onSave.emit(this.customerGroup);
		} catch (error) {
			this.app.msgSvc.add({ severity: AppMessageSeverity.RED, summary: "", detail: `There was an error saving the group.` });
		}
	}

	async menuItemListGet() {
		const resp = await this.focusdata.configMenuItemGetAllIdsOnly(this.venueKey);
		this.menuItemList = resp.map((i) => new MenuItemRecord(i));
	}

	filterCriteria() {
		if (this.customerGroup.criteria === CustomerVenueGroupCriteria.PURCHASEDITEM) {
			this.operator.forEach((rec) => {
				if (rec.value !== CompareOperator.EQUALS) {
					rec.disabled = true;
				}
			});
		} else {
			this.operator.forEach((rec) => {
				rec.disabled = false;
			});
		}
	}
}
